import React from 'react'
import Layout from '../components/layout'

import { Link } from 'gatsby'
import alanza from './images/Alianza.jpg'
import SEO from '../components/seo'

var OurAssociates = () => (
  <Layout>
    <SEO title="Our Associates" keywords={[]} />

    <div id="main" role="main">
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Our Associates</h1>
        <div>
          <img
            className="alignleft"
            style={{ float: 'left' }}
            title="Our Associates"
            src={alanza}
            alt
            width={405}
          />
        </div>
        <p>
          <em>Gómez &amp; Associates</em> is a tight circle of friends and
          colleagues that have similar values, mindsets and a variety of
          expertise and experiences to help individuals and organizations grow
          and develop. Compared to other training and development organizations
          that have one way of doing things, we are truly an alliance and
          association bringing together a group of professionals that each owns
          their own business. When Gómez &amp; Associates gather for a client
          engagement, our network approach brings clients the benefit of diverse
          perspectives, distinct experiences and the best solutions for the
          project; far removed from group think and stagnant methodologies. Our
          association affords us the exceptional ability to bring together
          consultants, coaches, facilitators and business professionals who
          fundamentally understand the challenges and needs facing individuals
          and companies today.
        </p>
        <p>
          Whether your pain point is the need for an initiative to develop
          leadership capacity; processes to drive innovation and creativity for
          new solutions and products or attracting, hiring, and retaining top
          talent, members of our team have been there. Let us bring over 20
          years of experience and firsthand knowledge to meet your
          organizational development needs and deliver the catalyst that
          unleashes the core potential that underlies every individual and
          organization.
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/elfego-gomez-iii">
            Elfego Gomez III
          </Link>
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/shanna-r-teel-ph">
            Dr. Shanna Teel, PhD
          </Link>
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/edwin-bodensiek">
            Edwin Bodensiek
          </Link>
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/stuart-parsons">
            Stuart Parsons
          </Link>
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/joette-borzik">
            Joette Borzak
          </Link>
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/steve-rudolph">
            Steve Rudolph
          </Link>
        </p>
        <p>
          <Link
            className="bio-link"
            to="/our-associates/michael-s-patterson-md"
          >
            Dr. Michael Patterson, MD
          </Link>
        </p>
        <p>
          <Link className="bio-link" to="/our-associates/christopher-lowell">
            Christopher Lowell
          </Link>
        </p>
      </div>
    </div>
  </Layout>
)

export default OurAssociates
